import { render, staticRenderFns } from "./BaseTab.vue?vue&type=template&id=78291246&scoped=true"
import script from "./BaseTab.vue?vue&type=script&lang=js"
export * from "./BaseTab.vue?vue&type=script&lang=js"
import style0 from "./BaseTab.vue?vue&type=style&index=0&id=78291246&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78291246",
  null
  
)

export default component.exports